//文字コードはutf-8

// YouTube動画の遅延読み込み
export function initYoutube() {
  const youtubeCards = document.querySelectorAll('.jsYoutube');

  if (!youtubeCards.length) return;

  youtubeCards.forEach((card) => {
    const videoContainer = card.querySelector('.jsYoutube__video');
    const playBtn = card.querySelector('.jsYoutube__video__btn');
    const thumbnail = videoContainer?.querySelector('.thumb');
    const textArea = card.querySelector('.jsYoutube__textArea');

    if (!videoContainer || !playBtn || !thumbnail) return;

    const videoId = videoContainer.getAttribute('data-video-id');
    if (!videoId) return;

    // 動画を再生する関数
    const playVideo = () => {
      // 既にiframeが生成されている場合は何もしない
      if (videoContainer.querySelector('iframe')) return;

      // iframeを生成
      const iframe = document.createElement('iframe');
      iframe.setAttribute('width', '392');
      iframe.setAttribute('height', '225');
      iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.style.position = 'absolute';
      iframe.style.top = '0';
      iframe.style.left = '0';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';

      // サムネイルとボタンを非表示
      thumbnail.style.display = 'none';
      playBtn.style.display = 'none';

      // ::beforeの疑似要素はCSSで非表示にするためクラスを追加
      videoContainer.classList.add('is-playing');

      // iframeを追加
      videoContainer.appendChild(iframe);
    };

    // 動画を停止する関数
    const stopVideo = () => {
      const iframe = videoContainer.querySelector('iframe');
      if (!iframe) return;

      // iframeを削除
      iframe.remove();

      // サムネイルとボタンを再表示
      thumbnail.style.display = 'block';
      playBtn.style.display = 'flex';

      // is-playingクラスを削除
      videoContainer.classList.remove('is-playing');
    };

    // カード全体のクリックイベント（再生用）
    const handleCardClick = (e) => {
      // textArea部分をクリックした場合
      if (textArea && textArea.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        // 再生中の場合は停止処理を行う
        if (videoContainer.classList.contains('is-playing')) {
          stopVideo();
        } else {
          // 再生中でない場合は再生
          playVideo();
        }
        return;
      }

      // 動画部分をクリックした場合は何もしない（再生中の場合）
      if (videoContainer.contains(e.target) && videoContainer.classList.contains('is-playing')) {
        return;
      }

      // それ以外の場合は再生
      e.preventDefault();
      e.stopPropagation();
      playVideo();
    };

    // クリックイベントリスナーを追加
    card.addEventListener('click', handleCardClick);
    card.style.cursor = 'pointer';
  });
}

